export default [
  {
    path: "/",
    redirect: "/ssoLogin",
  },
  {
    path: "/login",
    name: "login",
    meta: { title: "海尔二维码平台" },
    component: () => import("@/views/Login.vue")
  },
  {
    path: "/error",
    name: "error",
    meta: { title: "海尔二维码平台" },
    component: () => import("@/views/error.vue")
  },
  {
    path: "/ssoLogin",
    name: "ssoLogin",
    meta: { title: "海尔二维码平台" },
    component: () => import("@/views/ssoLogin.vue")
  },
  {
    path: "/dashboard",
    name: "dashboard",
    meta: { title: "海尔二维码平台" },
    component: () => import("@/views/dashboard/index"),
    children: [
      {
        path: "home",
        name: "home",
        meta: { title: "工作台" },
        component: () => import("@/components/Home")
      }
    ]
  }
];
